import { FC, Props } from "./typings";
import styles from "./styles.module.scss";
import { useContext, useEffect, useRef, useState } from "react";
import Popper from "components/Popper";
import { ITag, TagType } from "dto/ITag";
import classNames from "classnames";
import TagBadge from "components/TagBadge";
import tagsService from "api/tagsService";
import ChooseTagNew from "components/ChooseTagNew";
import { Tooltip } from "@mui/material";
import CasesContext from "contexts/CasesContext";
import { useTranslation } from "react-i18next";

const TagCell: FC<Props> = ({ element, tags, apiRef }) => {
  const { t } = useTranslation();
  const refTag = useRef(null);
  const { cases, setCases } = useContext(CasesContext);
  const { mutate: removeTag } = tagsService.useRemoveTagFromPackage();
  const [showTagsSmall, setShowTagsSmall] = useState(false);

  const [findedTags, setFindedTags] = useState<ITag[]>([]);

  useEffect(() => {
    const t = tags?.filter((tag) =>
      element?.TagIds?.find((iTag) => tag.Id === iTag)
    );

    setFindedTags(t);
  }, [element?.TagIds, tags]);

  const handleUpdateTags = (tags: ITag[]) => {
    const newCases = [...cases];

    const el = newCases.find(
      (c) => c.Id === element.Id && c.Kind === element.Kind
    );

    if (el) {
      el.TagIds = tags.map((t) => t.Id);
    }

    setCases(newCases);
  };

  const handleRemoveTag = (tag: ITag) => {
    removeTag(
      {
        Items: [{ Id: element.Id, Kind: element.Kind }],
        TagId: tag.Id,
      },
      {
        onSuccess: () => {
          setFindedTags(findedTags.filter((ftag) => ftag.Id !== tag.Id));
        },
      }
    );
  };

  const selectRow = () => {
    if (apiRef) {
      apiRef.current.selectRow(element.Id, true);
    }
  };

  return (
    <div
      className={classNames(
        styles.tags,
        findedTags && findedTags.length > 0 ? styles.notEmpty : styles.empty
      )}
      ref={refTag}
    >
      {findedTags && findedTags.length > 0 && (
        <div
          onClick={() => {
            selectRow();
            setShowTagsSmall(!showTagsSmall);
          }}
          key={`tag_${element.Id}_${findedTags[0].Id}`}
        >
          <TagBadge
            onRemove={(tag) => handleRemoveTag(tag)}
            tag={findedTags[0]}
          />
        </div>
      )}

      {findedTags && findedTags.length > 1 && (
        <div
          className={styles.moreTags}
          onClick={(e) => {
            setShowTagsSmall(!showTagsSmall);
            e.preventDefault();
            e.stopPropagation();
          }}
        >
          +{findedTags.length - 1}
        </div>
      )}

      {findedTags && findedTags.length === 0 && (
        <Tooltip title={t("tooltips.setTag")}>
          <div>
            <div
              className={styles.fakeBadge}
              onClick={(e) => {
                selectRow();
                setShowTagsSmall(!showTagsSmall);
                e.stopPropagation();
              }}
            >
              ...
            </div>
          </div>
        </Tooltip>
      )}

      {showTagsSmall && (
        <Popper
          anchorEl={refTag?.current}
          open={showTagsSmall}
          setOpen={setShowTagsSmall}
        >
          <ChooseTagNew
            toggle={setShowTagsSmall}
            updateTags={handleUpdateTags}
            type={TagType.Cases}
            //@ts-ignore
            toTag={element}
          />
        </Popper>
      )}
    </div>
  );
};

export default TagCell;
